import Vue from "vue";
import VueYandexMetrika from "vue-yandex-metrika";
import store from "./../store";
import router from "./../router";
import Cookies from "js-cookie";

function removeCookies(prefix) {
  Object.keys(Cookies.get())
    .filter((key) => key.startsWith(prefix))
    .forEach((key) => Cookies.remove(key, { path: "/" }));
}

function removeLocalstorage(prefix) {
  Object.keys(localStorage)
    .filter((key) => key.startsWith(prefix))
    .forEach((key) => localStorage.removeItem(key));
}

function removeAnalyticsKeys(prefix) {
  removeCookies(prefix);
  removeLocalstorage(prefix);
}

function startAnalytics() {
  // Yandex metrika
  Vue.use(VueYandexMetrika, {
    id: 104325901,
    router,
    env: process.env.NODE_ENV,
    options: {
      webvisor: true,
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
    },
  });
}

function stopAnalytics() {
  router.go();

  removeAnalyticsKeys("_ym");
  removeAnalyticsKeys("tmr_");
}

export function initAnalytics() {
  store.watch(
    (state) => state.cookieConsent.value,
    (newValue, oldValue) => {
      if (!oldValue && newValue) {
        startAnalytics();
      } else if (oldValue && !newValue) {
        stopAnalytics();
      }
    }
  );
}
